// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import MPCardDetailsInfoContainer from '../containers/MPCardDetailsInfoContainer';
import MPSwipeCardsContainer from '../containers/MPSwipeCardsContainer';

import MPViewWrapper from './common/MPViewWrapper';

const StyledMPSwipeCardsContainer = styled(MPSwipeCardsContainer)`
  margin-bottom: 0;
  margin-left: -1em;
  margin-right: -1em;
  padding-left: 1em;
  padding-right: 1em;
`;

type MPFamilyDetailsProps = {
  className?: string;
  betslipReferences?: string[];
};

const MPFamilyDetails = ({ className = '', betslipReferences = [] }: MPFamilyDetailsProps) => {
  const [index, setIndex] = useState(0);

  const handleChangeIndex = useCallback((index) => setIndex(index), []);

  return (
    <MPViewWrapper className={className}>
      <StyledMPSwipeCardsContainer onChangeCard={handleChangeIndex} />
      <MPCardDetailsInfoContainer betslipReference={betslipReferences[index]} />
    </MPViewWrapper>
  );
};

export default MPFamilyDetails;
